import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const ScheduleStyles = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: ${({ $railCollapsed }) =>
    $railCollapsed ? "44px 1fr" : "248px 1fr"};
  gap: 14px;
  height: calc(100vh - 220px);
  min-height: 0;
  transition: grid-template-columns 200ms ease;

  /* Stack the team rail above the timeline on smaller screens; a 248px side
     rail leaves the timeline unusably narrow on a phone. */
  ${media.maxTablet`
    grid-template-columns: 1fr;
    height: auto;
    gap: 12px;

    .main-card {
      height: 70vh;
      min-height: 420px;
    }
  `}

  .main-card {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.primary[100]};
    box-shadow: ${({ theme }) => theme.shadows.card};
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .placeholder {
    height: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.primary[400]};
  }
`;
